class FormatClass {
  constructor() {}

  public renderReadableExpirationTimestamp = (timestamp: number) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const year = date.getFullYear();

    // Get month name in three-letter format
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];

    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Ensure minutes are two digits
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${day} ${month} ${year}, ${hours}:${formattedMinutes}`;
  };

  public renderReadableDateOfBirth = (dateString: number) => {
    const date = new Date(dateString);
    // Check for invalid date
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZoneName: "short",
    }).format(date);
  };

  public formatDate = (date: string) => {
    const d = new Date(date);
    // return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    console.log(`using formatDate to get: ${d.toLocaleDateString()} ${d.toLocaleTimeString()}`);
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
  };

  public formatMDYDate = (date: string) => {
    if (typeof date === "string") {
      const month = date[5] == "0" ? date.slice(6, 7) : date.slice(5, 7);
      const day = date[8] === "0" ? date.slice(9, 10) : date.slice(8, 10);
      const year = date.slice(0, 4);
      return `${month}-${day}-${year}`;
    } else {
      return;
    }
  };

  public formatCalendarDate = (date: string) => {
    //for use with date types in forms
    if (typeof date === "string") {
      return date.slice(0, 10);
    } else {
      return;
    }
  };
}

const FormatInstance = new FormatClass();

export { FormatInstance };
